import React from 'react';

/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
const ManageOutsideCandidatesConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/upload/manageoutsidecandidates',
			component: React.lazy(() => import('./ManageOutsideCandidates'))
		}
	]
};

export default ManageOutsideCandidatesConfig;
/* Code end. Harsha using AI Agent. July 9, 2026 */
